import { useEffect, useState } from "react";
import { Quote, Play } from "lucide-react";
import { getTemoignages } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const monogramme = (nom) =>
  nom.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();

export const Temoignages = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    getTemoignages().then(setItems).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="border-t border-border bg-card py-28" data-testid="temoignages-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-primary">Témoignages</p>
          <h2 className="mt-6 max-w-2xl font-serif text-4xl font-medium leading-[1.15] tracking-tight md:text-5xl">
            Des parcours <span className="italic text-primary">transformés</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-x-14 gap-y-16 md:grid-cols-2">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={(i % 2) * 0.12}>
              <figure className="border-t-2 border-foreground/80 pt-8" data-testid={`temoignage-${i}`}>
                {t.video_path ? (
                  <div className="relative overflow-hidden border border-border bg-espresso" data-testid={`temoignage-video-${i}`}>
                    <video
                      src={`${BACKEND}/api/media/${t.video_path}`}
                      poster={`${BACKEND}/api/media/${t.video_path.replace(".mp4", ".jpg")}`}
                      controls
                      controlsList="nodownload"
                      onContextMenu={(e) => e.preventDefault()}
                      preload="metadata"
                      className="aspect-video w-full object-cover"
                    />
                  </div>
                ) : (
                  <>
                    <Quote size={26} strokeWidth={1.5} className="text-gold" aria-hidden="true" />
                    <blockquote className="mt-6 font-serif text-2xl font-medium italic leading-snug text-foreground/90">
                      « {t.texte} »
                    </blockquote>
                  </>
                )}
                <figcaption className="mt-8 flex items-center gap-4">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary/10 font-serif text-lg font-semibold text-primary">
                    {t.video_path ? <Play size={18} className="text-primary" /> : monogramme(t.nom)}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold" data-testid={`temoignage-nom-${i}`}>{t.nom}</span>
                    <span className="block text-xs text-foreground/50">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
